(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('menu-countdown')) return;

    class MenuCountdown extends HTMLElement {
      connectedCallback() {
        this.timer = this.querySelector('[data-timer]');
        this.closedMessage = this.querySelector('[data-closed]');
        this.units = {
          days: this.querySelector('[data-days]'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]')
        };
        this.deadline = new Date(this.dataset.expiry).getTime();
        this.render();
        this.interval = window.setInterval(() => this.render(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      render() {
        const remaining = this.deadline - Date.now();

        if (!Number.isFinite(this.deadline) || remaining <= 0) {
          this.timer.hidden = true;
          this.closedMessage.hidden = false;
          window.clearInterval(this.interval);
          document.querySelectorAll("form[action*='/cart/add'] button[type='submit'], form[action*='/cart/add'] button[name='add'], .shopify-payment-button button").forEach((button) => {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
          });
          return;
        }

        const seconds = Math.floor(remaining / 1000);
        this.units.days.textContent = String(Math.floor(seconds / 86400)).padStart(2, '0');
        this.units.hours.textContent = String(Math.floor((seconds % 86400) / 3600)).padStart(2, '0');
        this.units.minutes.textContent = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
        this.units.seconds.textContent = String(seconds % 60).padStart(2, '0');
      }
    }

    customElements.define('menu-countdown', MenuCountdown);
  })();

  } catch(e) { console.error(e); }
})();
})();
